import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import { cicToType } from "@/helpers/Helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
export default function Follower(t0) {
  const $ = _c(17);
  const {
    follower
  } = t0;
  let t1;
  if ($[0] !== follower.identity.cic) {
    t1 = cicToType(follower.identity.cic);
    $[0] = follower.identity.cic;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cicType = t1;
  let t2;
  if ($[2] !== follower.identity.handle || $[3] !== follower.identity.pfp) {
    t2 = <div className="tw-h-10 tw-w-10 tw-bg-iron-800 tw-relative tw-flex-shrink-0 tw-rounded-lg"><div className="tw-rounded-lg tw-h-full tw-w-full"><div className="tw-ring-1 tw-ring-inset tw-ring-white/5 tw-h-full tw-w-full tw-max-w-full tw-rounded-lg tw-overflow-hidden tw-bg-iron-800"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-overflow-hidden">{follower.identity.pfp ? <img src={follower.identity.pfp} alt={`${follower.identity.handle}'s profile`} className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" /> : <div className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" />}</div></div></div></div>;
    $[2] = follower.identity.handle;
    $[3] = follower.identity.pfp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== cicType || $[6] !== follower.identity.level) {
    t3 = <UserCICAndLevel level={follower.identity.level} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[5] = cicType;
    $[6] = follower.identity.level;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `/${follower.identity.handle}`;
  let t5;
  if ($[8] !== follower.identity.handle || $[9] !== t4) {
    t5 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold tw-text-iron-50"><Link href={t4} className="tw-no-underline hover:tw-underline hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{follower.identity.handle}</Link></p>;
    $[8] = follower.identity.handle;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="tw-flex tw-flex-col"><div className="tw-flex tw-items-center tw-gap-x-1"><div className="tw-items-center tw-flex tw-gap-x-2">{t3}{t5}</div></div></div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-3">{t2}{t6}</div>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}